import React, { useState } from 'react';
import { Plan } from './types';
import './AddPlanModal.css';

interface AddPlanModalProps {
    onSave: (plan: Plan, createInStripe: boolean) => void;
    onClose: () => void;
}

const AddPlanModal: React.FC<AddPlanModalProps> = ({ onSave, onClose }) => {
    const [newPlan, setNewPlan] = useState<Plan>({
        planId: '',
        stripeId: '',
        limits: {
            creditsAvailable: 0,
            HDGenerationAvailable: false,
            chatSessionsAvailable: 0
        },
        price: 0,
        period: 'month'
    });
    const [createInStripe, setCreateInStripe] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSave(newPlan, createInStripe);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Add new plan</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Plan ID:</label>
                        <input
                            type="text"
                            value={newPlan.planId}
                            onChange={(e) => setNewPlan({
                                ...newPlan,
                                planId: e.target.value
                            })}
                            placeholder="Enter plan ID"
                            required
                        />
                    </div>
                    
                    <div className="form-group checkbox-group">
                        <label>Create in Stripe:</label>
                        <input
                            type="checkbox"
                            checked={createInStripe}
                            onChange={(e) => setCreateInStripe(e.target.checked)}
                        />
                    </div>

                    {!createInStripe && (
                        <div className="form-group">
                            <label>Stripe ID:</label>
                            <input
                                type="text"
                                value={newPlan.stripeId}
                                onChange={(e) => setNewPlan({
                                    ...newPlan,
                                    stripeId: e.target.value
                                })}
                                placeholder="Enter Stripe ID"
                                required
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label>Available credits:</label>
                        <input
                            type="number"
                            value={newPlan.limits.creditsAvailable}
                            onChange={(e) => setNewPlan({
                                ...newPlan,
                                limits: {
                                    ...newPlan.limits,
                                    creditsAvailable: Number(e.target.value)
                                }
                            })}
                            min="0"
                            placeholder="Enter available credits"
                            required
                        />
                    </div>

                    <div className="form-group checkbox-group">
                        <label>HD Generation:</label>
                        <input
                            type="checkbox"
                            checked={newPlan.limits.HDGenerationAvailable}
                            onChange={(e) => setNewPlan({
                                ...newPlan,
                                limits: {
                                    ...newPlan.limits,
                                    HDGenerationAvailable: e.target.checked
                                }
                            })}
                        />
                    </div>

                    <div className="form-group">
                        <label>Available chat sessions:</label>
                        <input
                            type="number"
                            value={newPlan.limits.chatSessionsAvailable}
                            onChange={(e) => setNewPlan({
                                ...newPlan,
                                limits: {
                                    ...newPlan.limits,
                                    chatSessionsAvailable: Number(e.target.value)
                                }
                            })}
                            min="0"
                            placeholder="Enter available chat sessions"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Price (in cents):</label>
                        <div className="price-input">
                            <input
                                type="number"
                                value={newPlan.price}
                                onChange={(e) => setNewPlan({
                                    ...newPlan,
                                    price: Number(e.target.value)
                                })}
                                min="0"
                                placeholder="Enter price in cents"  
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Period:</label>
                        <select
                            value={newPlan.period}
                            onChange={(e) => setNewPlan({
                                ...newPlan,
                                period: e.target.value
                            })}
                            required
                        >
                            <option value="month">Month</option>
                            <option value="year">Year</option>
                        </select>
                    </div>

                    <div className="modal-buttons">
                        <button type="button" onClick={onClose} className="cancel-button">Cancel</button>
                        <button type="submit" className="save-button">Create plan</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddPlanModal; 